import { useState, useCallback } from 'react';
import { pw2202Api } from '../../../services/pw2202Api';

export function usePW2202Navigation(onNavigate: (id: string) => Promise<void>) {
  const [allIds, setAllIds] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  /** Load the full list of PW2202 IDs */
  const loadList = useCallback(async (): Promise<string[]> => {
    const res = await pw2202Api.list(1, 10000);
    const ids = (res.data || []).map(r => r.f2120_01).filter(Boolean);
    setAllIds(ids);
    return ids;
  }, []);

  /** Navigate to a specific index */
  const navTo = useCallback(async (idx: number, isEditing: boolean) => {
    if (idx < 0 || idx >= allIds.length || isEditing) return;
    setCurrentIdx(idx);
    await onNavigate(allIds[idx]);
  }, [allIds, onNavigate]);

  return {
    allIds, currentIdx,
    setAllIds, setCurrentIdx,
    loadList, navTo,
  };
}
